module.exports = __webpack_public_path__ + "img/twitter_sample_nice_icon.8d786d32.svg";